<script setup lang="ts">
    import { computed } from 'vue';
    import { usePlannerStore } from '@/views/3d-planner/store/plannerStore';
    import { useTemplateSyncStore } from '@/views/3d-planner/template/templateSyncStore';
    import SaveStatusIndicator from '@/components/SaveStatusIndicator.vue';

    const planner = usePlannerStore();
    const sync = useTemplateSyncStore();

    // Long-running operations (load / optimize / approve) take precedence and own
    // their own progress UI below. Otherwise we delegate the save lifecycle to the
    // shared SaveStatusIndicator, which owns the transient "Saved" state. The
    // template-sync store has no error channel — failures surface via the app error
    // store — so the sidebar only ever reports 'idle' or 'saving'.
    const saveState = computed<'idle' | 'saving'>(() => (sync.hasUpdate ? 'saving' : 'idle'));
</script>

<template>
    <div class="planner-status text-secondary-text">
        <div v-if="planner.currentOperation">
            <v-progress-circular indeterminate size="20" width="2" color="success" />
            <span v-if="planner.currentOperation === 'load-case'">Loading case ...</span>
            <span v-else-if="planner.currentOperation === 'set-targets'">
                Optimizing stems ...
            </span>
            <!-- One operation backs both acts, so the text names the outcome rather than the
                 act: a preparer proposing must not be told they are approving. -->
            <span v-else-if="planner.currentOperation === 'approve-plan'">Creating plan ...</span>
        </div>
        <save-status-indicator v-else :state="saveState" />
    </div>
</template>

<style scoped>
    .planner-status {
        font-size: 14px;
    }

    .planner-status > div {
        display: flex;
        align-items: center;
        gap: 8px;
    }
</style>
